import React from 'react';
import { Shield, BadgeCheck, Award, Star, Briefcase, FileCheck } from 'lucide-react';

const BADGE_META = {
  id_verified: { label: 'ID Verified', icon: Shield, color: 'bg-blue-100 text-blue-700' },
  license_verified: { label: 'License OK', icon: FileCheck, color: 'bg-emerald-100 text-emerald-700' },
  insurance_verified: { label: 'Insured', icon: BadgeCheck, color: 'bg-indigo-100 text-indigo-700' },
  training_completed: { label: 'Trained', icon: Briefcase, color: 'bg-purple-100 text-purple-700' },
  top_rated: { label: 'Top Rated', icon: Star, color: 'bg-amber-100 text-amber-700' },
  background_checked: { label: 'Background Checked', icon: Award, color: 'bg-teal-100 text-teal-700' },
};

const DriverBadgeChips = ({ badges = [] }) => {
  if (!badges || badges.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1 mt-2" data-testid="driver-badges">
      {badges.map((b, idx) => {
        const meta = BADGE_META[b.type] || { label: b.type, icon: Shield, color: 'bg-gray-100 text-gray-700' };
        const Icon = meta.icon;
        return (
          <span key={idx} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium ${meta.color}`} title={b.notes || meta.label}>
            <Icon className="h-3 w-3" />
            {meta.label}
          </span>
        );
      })}
    </div>
  );
};

export default DriverBadgeChips;
